"use strict";
document.addEventListener("DOMContentLoaded", () => {
    const headerButtons = document.querySelectorAll(".expandable-header-button");
    function updateExpandButton(button, text, isExpanded) {
        for (let node of button.childNodes) {
            if (node.nodeType === Node.TEXT_NODE) {
                node.nodeValue = text;
                break;
            }
        }
        const icon = button.querySelector("i");
        if (icon && !button.firstChild.nodeValue) {
            button.insertBefore(document.createTextNode(text), icon);
        }
        const chevronIcon = button.querySelector(".expandable-card-icon");
        if (chevronIcon) {
            chevronIcon.classList.toggle("expandable-card-icon--rotate-180", isExpanded);
        }
        button.setAttribute("aria-expanded", isExpanded.toString());
    }
    const numberOfShownPanels = (cardsContainer) => {
        const cards = cardsContainer.querySelectorAll(".expandable-card");
        let count = 0;
        for (const card of cards) {
            if (card.classList.contains("expanded")) {
                count++;
            }
        }
        return count;
    };
    const toggleAllCardButtonState = (headerButton, cardsContainer) => {
        if (numberOfShownPanels(cardsContainer) > 1) {
            if (headerButton) {
                headerButton.setAttribute("data-expand-cards-state", "hide");
                const textNode = headerButton.querySelector(".expandable-header-button-text");
                textNode
                    ? (textNode.textContent = "Close all")
                    : (headerButton.textContent = "Close all");
            }
        }
        else {
            if (headerButton) {
                headerButton.setAttribute("data-expand-cards-state", "show");
                const textNode = headerButton.querySelector(".expandable-header-button-text");
                textNode
                    ? (textNode.textContent = "Expand all")
                    : (headerButton.textContent = "Expand all");
            }
        }
    };
    const expandCard = (card) => {
        const body = card.querySelector(".expandable-card-body");
        const button = card.querySelector(".expandable-card-btn");
        const cardsContainer = card.closest(".expandable-cards");
        const headerButton = document.querySelector(`.expandable-header-button[aria-controls="${cardsContainer.id}"]`);
        const readLessString = cardsContainer?.dataset?.readLess ?? "Read less";
        body.classList.add("expandable-card-body-expanded");
        card.classList.add("expanded");
        updateExpandButton(button, readLessString, true);
        const sectionHeight = body.scrollHeight;
        body.style.height = `${sectionHeight}px`;
        const onTransitionEnd = function (e) {
            body.removeEventListener("transitionend", onTransitionEnd);
            body.style.height = null;
        };
        body.addEventListener("transitionend", onTransitionEnd);
        toggleAllCardButtonState(headerButton, cardsContainer);
    };
    const collapseCard = (card) => {
        const body = card.querySelector(".expandable-card-body");
        const button = card.querySelector(".expandable-card-btn");
        const shouldShowContent = card.classList.contains("expandable-card-show-content");
        const cardsContainer = card.closest(".expandable-cards");
        const headerButton = document.querySelector(`.expandable-header-button[aria-controls="${cardsContainer.id}"]`);
        const readAllString = cardsContainer?.dataset?.readAll ?? "Read all";
        const sectionHeight = body.scrollHeight;
        body.style.height = `${sectionHeight}px`;
        body.offsetHeight;
        body.style.height = `${shouldShowContent ? 120 : 0}px`;
        body.classList.remove("expandable-card-body-expanded");
        card.classList.remove("expanded");
        updateExpandButton(button, readAllString, false);
        const onTransitionEnd = function () {
            body.removeEventListener("transitionend", onTransitionEnd);
        };
        body.addEventListener("transitionend", onTransitionEnd);
        toggleAllCardButtonState(headerButton, cardsContainer);
    };
    headerButtons.forEach((headerButton) => {
        headerButton.addEventListener("click", () => {
            const expanderCardsContainer = document.querySelector(`.expandable-cards#${headerButton.getAttribute("aria-controls")}`);
            const cards = expanderCardsContainer.querySelectorAll(".expandable-card");
            const isExpanded = (card) => {
                const body = card.querySelector(".expandable-card-body");
                return body.classList.contains("expandable-card-body-expanded");
            };
            const collapseState = headerButton.getAttribute("data-expand-cards-state");
            if (collapseState === "show") {
                cards.forEach((card) => {
                    if (!isExpanded(card)) {
                        expandCard(card);
                    }
                });
                headerButton.setAttribute("data-expand-cards-state", "hide");
                const textNode = headerButton.querySelector(".expandable-header-button-text");
                if (textNode) {
                    textNode.textContent = "Close all";
                }
                else {
                    headerButton.textContent = "Close all";
                }
            }
            else {
                cards.forEach((card) => {
                    if (isExpanded(card)) {
                        collapseCard(card);
                    }
                });
                headerButton.setAttribute("data-expand-cards-state", "show");
                const textNode = headerButton.querySelector(".expandable-header-button-text");
                if (textNode) {
                    textNode.textContent = "Expand all";
                }
                else {
                    headerButton.textContent = "Expand all";
                }
            }
        });
    });
    const cards = document.querySelectorAll(".expandable-card");
    cards.forEach((card) => {
        const body = card.querySelector(".expandable-card-body");
        const button = card.querySelector(".expandable-card-btn");
        const shouldShowContent = card.classList.contains("expandable-card-show-content");
        const cardsContainer = card.closest(".expandable-cards");
        const readAllString = cardsContainer?.dataset?.readAll ?? "Read all";
        const readLessString = cardsContainer?.dataset?.readLess ?? "Read less";
        if (shouldShowContent && body.scrollHeight > 120) {
            body.style.height = "120px";
            body.style.overflow = "hidden";
            updateExpandButton(button, readAllString, false);
        }
        else if (shouldShowContent) {
            body.style.height = "auto";
            button.style.display = "none";
            body.classList.add("expandable-card-body-expanded");
            updateExpandButton(button, readLessString, true);
        }
        else {
            body.style.height = "0px";
            updateExpandButton(button, readAllString, false);
        }
        button.addEventListener("click", () => {
            if (button.getAttribute("aria-expanded") === "false") {
                expandCard(card);
            }
            else {
                collapseCard(card);
            }
        });
    });
    function goToAnchor(url) {
        if (url) {
            const hashIndex = url.indexOf("#");
            if (hashIndex > -1) {
                const hash = url.substring(hashIndex + 1);
                const targetCard = document.getElementById(`expandable-card-item-${hash}`);
                if (targetCard && targetCard.classList.contains("expandable-card")) {
                    expandCard(targetCard);
                    setTimeout(() => {
                        targetCard.scrollIntoView({ block: "start", behavior: "smooth" });
                    }, 300);
                }
            }
        }
    }
    goToAnchor(window.location.href);
});
//# sourceMappingURL=ds-expandable-card.js.map